import { UserResource } from 'src/resources'

// to have the user at the top of the list
export const reorderTeam = (team: UserResource[], userId: number): UserResource[] => {
  const orderedArray = team.filter((member) => member.id === userId)
  const merchantUsersArray = team.filter((member) => member.id !== userId)
  merchantUsersArray.map((member) => orderedArray.push(member))
  return orderedArray
}
